export default "__VITE_ASSET__CFYAMdCs__"